import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar-clock",
  "use": "calendar-clock-usage",
  "viewBox": "0 0 23 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 22\" id=\"calendar-clock\"><path d=\"M11.5 0c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm0 2.278a8.722 8.722 0 100 17.444 8.722 8.722 0 000-17.444zm.972 3.34v5.565l3.218 2.803-1.313 1.508-3.905-3.4V5.617h2z\" fill=\"#2D2D2D\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol